export const POWERFULL_MERCHANT_BASE_URL =
  process.env.REACT_APP_POWERFULL_MERCHANT_BASE_URL;

export const POWERFULL_APP_BASE_URL =
  process.env.REACT_APP_POWERFULL_APP_BASE_URL;
